import axios from 'axios';

export const API = axios.create({
  baseURL: '/public/api/v1/scheduling',
});
